import { render } from "./PWAPrompt.vue?vue&type=template&id=41a37160"
import script from "./PWAPrompt.vue?vue&type=script&lang=js"
export * from "./PWAPrompt.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__